<!-- Компонент сохранения черновиков по таймеру -->
<template/>

<script>
	import axios from 'axios'
	import draftCommon from './draft-common.js'
	import _ from 'underscore'

	var isWizard = typeof process === 'object' && process.versions && process.versions['electron'];

	export default {
		name: 'DraftSaver',
		props: {
			arm_name: {
				type: String,
				// required: true,
			},
			draft_prop: {
				type: Object,
				required: true,
			},
		},
		data() {
			var intervalParam = draftCommon.intervalMemory.get();

			var _throttledFunc;
			if (intervalParam === 0) {
				_throttledFunc = function() {}
			}
			else {
				_throttledFunc = _.throttle(this.doSaveRequest, intervalParam * 1000)
			}

			var initialFieldsParsed = draftCommon.getFieldsWithPrettyValueForDiff(JSON.parse(this.$props.draft_prop.initialFieldsStr || '[]'));

			return {
				requestPending: false,
				doSaveAfterRequestEnds: false,
				cnt: 0,
				/** поля начинающиеся с педали для экономии становятся нереактивными */
				_initialFieldsParsed: initialFieldsParsed,
				// // https://underscorejs.org/#throttle
				_throttledFunc,
				err403notShown: true,
				locationHref: window.location.href, // запоминается потому что самый последний запрос может случиться уже после перехода на новый урл, например при возвращении в список
			}
		},
		methods: {
			EXT_doSave: function(currentFields) { // EXT_ значит что метод вызывается извне
				this.$data._throttledFunc(currentFields);
			},
			doSaveRequest: function(currentFields) {
				var vm = this;
				var draftProp = this.$props.draft_prop;

				var flowCrutchData = {
					armId: draftProp.armId,
					siteId: draftProp.siteId,
					recordId: draftProp.recordId,
				}

				// Ситуация, когда последний запрос POST идёт после того как нажали на Сохранить
				if (draftCommon.flowCrutch_check(flowCrutchData)) {
					draftCommon.log('flowCrutch prevented draft save');
					return
				}

				if (vm.$data.doSaveAfterRequestEnds === true) {
					// ситуация, когда запрос на сохранение черновика длился больше intervalParam
					// в этом случае в данном вызове функции ничего не делаем
					return
				}
				if (vm.$data.requestPending === true) {
					vm.$data.doSaveAfterRequestEnds = true;
				}
				else {
					vm.$data.requestPending = true;
				}

				var initialFields = vm.$data._initialFieldsParsed;

				draftCommon.mergeNamesFromInitialFieldsToCurrentFields(currentFields, initialFields);
				currentFields = draftCommon.getFieldsWithPrettyValueForDiff(currentFields);

				var draftPayload = {
					initialData: draftCommon.getFieldsForRequest(initialFields), // изначальное состояние записи
					draftData: draftCommon.getFieldsForRequest(currentFields), // текущее состояние записи
					armId: draftProp.armId,
					siteId: draftProp.siteId,
					recordId: draftProp.recordId,
					editUrl: this.$data.locationHref,
					armName: this.$props.arm_name,
				}

				draftCommon.log('draft_saver: сохранение №' + (++this.$data.cnt), draftPayload);

				// https://cwp.nu.oooinex.ru/draft/swagger-ui.html
				axios.post(draftCommon.serviceUrl, draftPayload).then(function(res) {
					if (res.data && res.data.success) {
						draftCommon.log('draft_saver: успех');
					}
					else {
						throw new Error('RID: ' + (res.data && res.data.rid));
					}
				}).catch(function(thrown) {
					var status = thrown.response && thrown.response.status;
					if (status === 403) {
						if (vm.$data.err403notShown && !isWizard) {
							// в визарде авторизация не нужна и этот алерт задалбывает
							window.alert('Ваша сессия истекла. Все изменения, сделанные вами, сохранены в черновике. Пожалуйста, войдите повторно');
							vm.$data.err403notShown = false; // кажем один раз
						}
					}
					else {
						console.log('draft_saver: ошибка', thrown);
					}
				}).then(function() {
					vm.$data.requestPending = false;
					if (vm.$data.doSaveAfterRequestEnds === true) {
						vm.$data.doSaveAfterRequestEnds = false;
						this.$data._throttledFunc();
					}
				})
			}
		}
	}
</script>
